import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * SiteSchema - Global Structured Data Component
 * Single Source of Truth for:
 * 1. Organization (XtreamGate)
 * 2. WebSite (XtreamGate)
 * 
 * This component should be mounted ONCE at the root (App.js)
 * to prevent schema duplication and provide a consistent graph.
 */
export const SiteSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@graph": [
            // Organization Entity
            {
                "@type": "Organization",
                "@id": "https://xtreamgate.com/#organization",
                "name": "XtreamGate",
                "alternateName": "XtreamCube Gateway",
                "description": "Official verified gateway to XtreamCube IPTV services, providing secure access to premium streaming with 20,000+ channels worldwide.",
                "url": "https://xtreamgate.com",
                "logo": {
                    "@type": "ImageObject",
                    "@id": "https://xtreamgate.com/#logo",
                    "url": "https://xtreamgate.com/logo.png",
                    "width": 512,
                    "height": 512
                },
                "foundingDate": "2017",
                "contactPoint": {
                    "@type": "ContactPoint",
                    "email": "support@xtreamcube.com",
                    "contactType": "Customer Support",
                    "availableLanguage": ["English"],
                    "areaServed": "Worldwide"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.9",
                    "ratingCount": "10000",
                    "bestRating": "5",
                    "worstRating": "1"
                },
                "sameAs": [
                    "https://xtreamcube.shop",
                    "https://xtreamcube.xyz",
                    "https://xtreamcube.online"
                ]
            },
            // WebSite Entity
            {
                "@type": "WebSite",
                "@id": "https://xtreamgate.com/#website",
                "name": "XtreamGate",
                "url": "https://xtreamgate.com",
                "description": "Official XtreamCube IPTV Gateway - Best IPTV provider 2026",
                "publisher": {
                    "@id": "https://xtreamgate.com/#organization"
                },
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                        "@type": "EntryPoint",
                        "urlTemplate": "https://xtreamgate.com?q={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                }
            }
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};
